<template>
    
    <div >

        <div class="timeline">

            <template v-for="(item, index) in this.timeLineTicket" :key="item">

                <div :class="['timeline-item', index % 2 === 0 ? 'left' : 'right']">
                    <span class="icon">{{ index+1 }}</span>
                    <div class="date fw-semibold fs-16" style="top:40px" >{{ mutateType(item.type) }}</div>
                    <div class="date" style="top: 70px;">{{ item.date }}</div>
                    
                    <div class="content" >
                        <div class="d-flex" >
                            <div class="flex-shrink-0" >
                                <div class="avatar-xs"  style="margin: 0px auto;" >
                                    <div class="avatar-title rounded bg-soft-info text-info"  >
                                        {{ this.getInitials(item.workerName ) }}
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1 ms-3" >
                                <h5 class="fs-15">{{ item.workerName }} <small class="text-muted fs-13 fw-normal">- {{ item.time }}</small></h5>
                               
                                <!-- Перевірка наявності oldProblemEnvironment в historyData -->
                                <p 
                                    v-if="item.historyData && item.historyData.oldProblemEnvironment" 
                                    class="text-muted mb-2"
                                >
                                    {{ $t('ChangeEnvironmentWith') }} <strong>{{ this.mutateProblemEnv(item.historyData.oldProblemEnvironment) }}</strong> {{ $t('on') }} <strong>{{ this.mutateProblemEnv(item.historyData.newProblemEnvironment) }}</strong>
                                </p>

                                <!-- Перевірка наявності oldPriority в historyData -->
                                <p 
                                    v-if="item.historyData && item.historyData.oldPriority" 
                                    class="text-muted mb-2"
                                >
                                {{ $t('ChangedPriorityFrom') }} <strong>{{ this.mutatepriority(item.historyData.oldPriority).name }}</strong> {{ $t('on') }} <strong>{{ this.mutatepriority(Number(item.historyData.newPriority)).name }}</strong>
                                </p>

                                <!--
                                    Орієнтовна дата виконання
                                    - приходить в historyData як при взятті в роботу (inJobTicket),
                                      так і при окремому редагуванні (editEstimatedDate)
                                -->
                                <p
                                    v-if="item.historyData && (item.historyData.newEstimatedDate || item.historyData.oldEstimatedDate)"
                                    class="text-muted mb-2"
                                >
                                    <!-- дату змінили з однієї на іншу -->
                                    <template v-if="item.historyData.oldEstimatedDate && item.historyData.newEstimatedDate">
                                        {{ $t('ChangedEstimatedDateFrom') }} <strong>{{ item.historyData.oldEstimatedDate }}</strong> {{ $t('on') }} <strong>{{ item.historyData.newEstimatedDate }}</strong>
                                    </template>

                                    <!-- дату вказали вперше -->
                                    <template v-else-if="item.historyData.newEstimatedDate">
                                        {{ $t('SetEstimatedDate') }} <strong>{{ item.historyData.newEstimatedDate }}</strong>
                                    </template>

                                    <!-- дату очистили -->
                                    <template v-else>
                                        {{ $t('ClearedEstimatedDate') }}
                                    </template>
                                </p>

                                <p class="text-muted mb-2" v-if="item.comment">
                                    {{ item.comment }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </template>

        </div>

    </div>

</template>


<script>
import { Tickets } from '@/API.js';
import { mutateTypeTimelineTicket, mutateProblemEnv, mutatePriorityTicket } from '@/usabilityScripts/globalMutate.js'

let apiServe = new Tickets();

export default {
    props: ['obj'],
    data() {
        return {
            form: '',
            timeLineTicket: [],
            testTimeLine: [
                {
                    date: '01.05.2024',
                    time: '00:35',
                    user: 'Віктор',
                    action_desc: '',
                    comment: '',
                    type: 'create_ticket',
                },
                {
                    date: '01.05.2024',
                    time: '01:01',
                    user: 'Віктор',
                    action_desc: 'З Пос-термінал на Адмін-панель',
                    type: 'changeProblem',
                },
                {
                    date: '01.05.2024',
                    time: '01:45',
                    user: 'Віктор',
                    action_desc: 'Змінено пріоритет з Низький на Високий',
                    comment: '',
                    type: 'changePriority',
                },
                {
                    date: '11.05.2024',
                    time: '10:15',
                    user: 'Сергій',
                    action_desc: '',
                    comment: '',
                    type: 'in_job_ticket',
                },
                {
                    date: '11.05.2024',
                    time: '14:15',
                    user: 'Олег',
                    action_desc: '',
                    comment: '',
                    type: 'joining_ticket',
                },
                {
                    date: '12.05.2024',
                    time: '16:45',
                    user: 'Сергій',
                    action_desc: '',
                    comment: 'Була помилка з боку серверів, виправили з ..',
                    type: 'decided_ticket',
                },
                {
                    date: '14.05.2024',
                    time: '14:30',
                    user: 'Олег',
                    action_desc: '',
                    comment: '',
                    type: 'exit_ticket',
                },
                {
                    date: '15.05.2024',
                    time: '19:01',
                    user: 'Віктор',
                    action_desc: '',
                    comment: 'Проблема залишилась',
                    type: 'reopen_ticket',
                },
                {
                    date: '16.05.2024',
                    time: '10:05',
                    user: 'Сергій',
                    action_desc: '',
                    comment: 'Знайшли проблему, вирішили',
                    type: 'decided_ticket',
                },
                {
                    date: '16.05.2024',
                    time: '18:33',
                    user: 'Віктор',
                    action_desc: '',
                    comment: 'Дякую, проблема була вирішена',
                    type: 'close_ticket',
                },
            ]
        }
    },
    created(){
        this.getdata()
        this.getdata1();
    },
    methods: {
        getdata(){
            this.form = this.obj
        },
        getdata1(){
            console.log("form> ", this);
            apiServe.getTicketHistory(this.form.ticketId).then(result => {
                console.log("res", result);
                if(result.status == "done"){
                    this.timeLineTicket = result.data.items
                } else {
                    this.$toast.error(this.$t("err"))
                }
                
            })
        },
        getInitials(string) {
            // Отримання ініціалів з імені користувача

            var names = string.split(' '),
            initials = names[0].substring(0, 1).toUpperCase();
            
            if (names.length > 1) {
                initials += names[names.length - 1].substring(0, 1).toUpperCase();
            }
            return initials;
        },
        mutateType(e){
            // мутейт типу
            return mutateTypeTimelineTicket(e)
        },
        mutatepriority(e){
            // мутейт пріорітету
            return mutatePriorityTicket(e)
        },
        mutateProblemEnv(e){
            // мутейт середовища проблеми
            return mutateProblemEnv(e)
        },
    }
    
}
</script>


<!-- 
Життя тікету - 

- Створення + 
- Перегляд -
- Взяття в роботу +
- Додавання рішення +
- Закриття тікету +
- Видалення тікету

Додатково - 
- Змінення пріоритету + 
- Зміна середовища проблеми + 
- Приєднання до тікету +
- Вихід з тікету +
- Відновлення тікету
- Перевідкриття тікету +
- Запит на допомогу 
- Перепризначення

-->